import TagManager from 'react-gtm-module';

const args = {
  gtmId: window.REACT_APP_GOOGLE_TAG_MANAGER_ID,
};

/**
 * @param {String} event
 * @param {Object} data
 */
const sendTagEvent = (event, data) =>
  TagManager.dataLayer({ dataLayer: { event, gtm: null, ...data } });

const GoogleTagManager = {
  init: () => TagManager.initialize(args),
  /**
   * @param {String} section
   * @param {Object} data
   */
  sendButton: (section, data = {}) => sendTagEvent('click', { section, data, type: 'Button' }),
  /**
   * @param {String} section
   * @param {Object} data
   */
  sendTab: (section, data = {}) => sendTagEvent('section', { section, data, type: 'Tab' }),
  /**
   * @param {String} section
   * @param {Object} data
   */
  sendSubmit: (section, data = {}) => sendTagEvent('click', { section, data, type: 'Submit' }),
  /**
   * @param {String} section
   * @param {Object} data
   */
  sendInput: (section, data = {}) => sendTagEvent('input', { section, data, type: 'Input' }),
};

export default GoogleTagManager;
